namespace advisorop.components.meetinghub {
    export class InvestorMeetingSelectorController {

        //availableMeetingTime: Array<domains.IMeetingAvailability> = []

        constructor(private meetingHubService: services.MeetingHubService) {

        }

        loadAvailableMeeting(): void {

        }

        $onInit(): void {
        }

    }

    class InvestorMeetingSelector implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
            };
            this.controller = [`meetingHubService`, InvestorMeetingSelectorController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/meeting-hub-module/components/investor-meeting-selector.html`;
        }
    }
    angular.module(Constants.APP).component(`investorMeetingSelector`, new InvestorMeetingSelector());
}